import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Grid from '../../../common/components/Grid'
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField'
import Divider from 'material-ui/Divider'
import {Link} from 'react-router-dom'
import FacebookLoginButton from 'react-facebook-login'
import LoadingButton from '../../../common/components/LoadingButton'
import {login as text} from '../text'
import {Container, Title} from '../../flow'
import LoadingIndicator from '../../../components/loadingIndicator'

const styles = theme => ({
  root: {
    margin: '50px 0',
  },
  Dialog: {
    backgroundColor: theme.palette.background.modal,
  },
  logo: {
    objectFit: 'scale-down',
  },
  container: {
    maxWidth: 310,
    margin: '0 auto',
    padding: '35px 0',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: 16,
    right: 16,
  },
  grid: {
    paddingTop: theme.spacing.unit * 4,
  },
  textField: {
    width: 280,
  },
  separator: {
    display: 'flex',
  },
  button: {
    width: 280,
    height: 44,
  },
  error: {
    color: 'red',
  },
  link: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  divider: {
    width: 65,
    position: 'relative',
    top: 8,
  },
  o: {
    width: 150,
  },
  facebookButton: {
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    padding: '13px 8px 8px 8px',
    boxSizing: 'border-box',
  },
})

class Login extends React.Component {

  handleSignInClick = (e) => {
    e.preventDefault()
    this.props.continueEmail()
  }

  componentDidMount() {
    this.props.updateUrl()
  }

  render() {
    const {classes} = this.props
    return (
      <Container className={classes.container}>
        <div style={{textAlign: 'center', marginTop: 0}}>
          <img src="/assets/logo.png" width={42} height={42} className={classes.logo} alt="logo"/>
        </div>
        <Title className={classes.title}>{text.hi}</Title>
        <form noValidate autoComplete="off">
          <LoadingIndicator show={this.props.isFormLoading}>
            <Grid container justify="center" direction="column" alignItems="center" className={classes.grid}>
              <Grid item xs={12} safariFix={true}>
                <Typography variant="body1">
                  <span style={{color: '#5B687C'}}>{text.iDontHaveAnAccount} </span>
                  <span className={classes.link} onClick={this.props.goToSignUp}>{text.signUpNow}</span>
                </Typography>
              </Grid>
              <Grid item xs={12} safariFix={true} style={{paddingTop: 45}}>
                <LoadingButton
                  variant="primary"
                  isLoading={this.props.facebookIsFetching}
                  className={classes.button}
                  component="div"
                  style={{backgroundColor: '#2160BE', width: 280}}
                >
                  <FacebookLoginButton
                    appId="1762190754086991"
                    fields="name,email"
                    reAuthenticate={false}
                    callback={this.props.continueFacebook}
                    cssClass={classes.facebookButton}
                    textButton={text.loginWithFacebook}
                    disableMobileRedirect={true}
                    tag="div"
                  />
                </LoadingButton>
              </Grid>
              {
                this.props.facebookError !== '' &&
                <Grid item xs={12} safariFix={true}>
                  <Typography className={classes.error}>{this.props.facebookError}</Typography>
                </Grid>
              }
              <Grid item xs={12} safariFix={true} style={{paddingTop: 20, paddingBottom: 10}}>
                <div className={classes.separator}>
                  <Divider className={classes.divider}/>
                  <Typography align="center" className={classes.o}> {text.or} </Typography>
                  <Divider className={classes.divider}/>
                </div>
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <TextField
                  id="email"
                  label={text.email}
                  autoComplete="email"
                  className={classes.textField}
                  type="email"
                  onChange={e => this.props.setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <TextField
                  id="password"
                  type="password"
                  label={text.password}
                  autoComplete="current-password"
                  className={classes.textField}
                  onChange={e => this.props.setPassword(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <Typography className={classes.error}>{this.props.emailError}</Typography>
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <LoadingButton
                  variant="primary"
                  onClick={this.handleSignInClick}
                  type="submit"
                  isLoading={this.props.emailIsFetching}
                  style={{width: 280}}
                >
                  {text.logIn}
                </LoadingButton>
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <Typography variant="body1">
                  <Link to="/recuperar" className={classes.link}
                        onClick={() => {this.props.close()}}>{text.iForgotMyPassword}</Link>
                </Typography>
              </Grid>
            </Grid>
          </LoadingIndicator>
        </form>
      </Container>
    )
  }
}

Login.propTypes = {
  email: PropTypes.string,
  password: PropTypes.string,
  emailError: PropTypes.string,
  setEmail: PropTypes.func,
  setPassword: PropTypes.func,
  continueEmail: PropTypes.func,
  emailIsFetching: PropTypes.bool,
  facebookIsFetching: PropTypes.bool,
  facebookError: PropTypes.string,
  continueFacebook: PropTypes.func,
  isFormLoading: PropTypes.bool,
  goToSignUp: PropTypes.func,
  close: PropTypes.func,
  updateUrl: PropTypes.func.isRequired,
}

const StyledLogin = withStyles(styles, {withTheme: true})(Login)

export default StyledLogin



// WEBPACK FOOTER //
// ./src/sections/depositV2/components/login.step.jsx